import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { BillingTypeStateClass } from './interfaces/billingTypeStateClass';
import { sortData } from '../../../common/timeLiveFunction';
const initialState: BillingTypeStateClass = {
    isLoading: false,
    status: 'idle',
    billingTypeList: [],
    selectedRecord: {},
    isReload : false,
    sortOrder: 'asc',
    sortColumn: 'BillingType',
    search: '',
    pageNo: 1,
    pageSize: 10
}
interface IThunkApi {
    state: {
        billingType: BillingTypeStateClass;
    },
}
export const getBillingTypeAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'billingType/getBillingType',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/BillingTypes', 'Get', '', true, 'd8667f9b-57fd-4ca8-9496-59cbebb5f944');
            const json = await response.json();
            return json;
        }
    )

export const getBillingTypeByIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'billingType/getBillingTypeById',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/BillingTypes/' + arg, 'Get', '', true, 'd8667f9b-57fd-4ca8-9496-59cbebb5f944');
            const json = await response.json();
            return json;
        }
    )

    
    export const addBillingTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'billingType/addBillingType',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/BillingTypes/', 'POST', arg, true, 'd8667f9b-57fd-4ca8-9496-59cbebb5f944');
            const json = await response.json();
            return json;
        }
    )

    export const updateBillingTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'billingType/UpdateBillingType',
        async (arg, thunkApi) => {
            const { AccountBillingTypeId,BillingCategory, ...argWithoutId } = arg;
            const response = await fetchAPI('api/v2/BillingTypes/' + AccountBillingTypeId, 'PUT', argWithoutId, true, 'd8667f9b-57fd-4ca8-9496-59cbebb5f944');
            const json = await response.json();
            return json;
        }
    )

    export const deleteBillingTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'billingType/deleteBillingType',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/BillingTypes/' + arg, 'DELETE', '', true, 'd8667f9b-57fd-4ca8-9496-59cbebb5f944');
            const json = await response.json();
            return json;
        }
    )

    export const deleteAllSelectedRecordBillingTypeAsync = createAsyncThunk
    <any,any,IThunkApi>
    (
        "paymentMethod/DeleteAllSelectedRecordBillingType",
        async(arg,thunkApi) =>{
            console.log('farhan',arg);
            const response = await fetchAPI('api/v2/BillingTypes/DeleteAllSelectedRecordBillingType/', 'DELETE', arg, true,'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json =await response.json();
            return json;
        
        }
    )


  
export const billingTypeSlice = createSlice({
    name: 'billingType',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        checkedState: (state, action) => {
            const currentindex = state.billingTypeList.findIndex((item) => item.AccountBillingTypeId == action.payload);
            const newArray = [...state.billingTypeList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected : 1 };
            state.billingTypeList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.billingTypeList.findIndex((item) => item.AccountBillingTypeId == action.payload);
            const newArray = [...state.billingTypeList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.billingTypeList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.billingTypeList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.billingTypeList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedAllState: (state) => {
            const newArray = state.billingTypeList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.billingTypeList = newArray;
            //state.isAllUnChecked = true;
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.billingTypeList;
            state.billingTypeList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getBillingTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading= true;

            })
            .addCase(getBillingTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Object.keys(payload.Data).length === 0) {
                    state.billingTypeList = [];
                } else {
                    state.billingTypeList = payload.Data;
                    state.billingTypeList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
                console.log('billingTypeList :', payload);
            })
            .addCase(getBillingTypeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading= false;
            })
           .addCase(getBillingTypeByIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading= true;

            })
            .addCase(getBillingTypeByIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading= false;
                console.log('getBillingTypeByIdAsync.fulfilled', payload);
                state.selectedRecord = payload.Data[0];
            })
            .addCase(getBillingTypeByIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading= false;
            })
            .addCase(addBillingTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading= true;

            })
            .addCase(addBillingTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading= false;
            })
            .addCase(addBillingTypeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading= false;
            })
           
            .addCase(updateBillingTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading= true;

            })
            .addCase(updateBillingTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading= false;
            })
            .addCase(updateBillingTypeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading= false;
            })
            .addCase(deleteBillingTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading= true;

            })
            .addCase(deleteBillingTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading= false;
            })
            .addCase(deleteBillingTypeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading= false;
            })
            .addCase(deleteAllSelectedRecordBillingTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading= true;

            })
            .addCase(deleteAllSelectedRecordBillingTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading= false;
            })
            .addCase(deleteAllSelectedRecordBillingTypeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading= false;

            })
    }
})
export const {
    resetSelectedRecordObjectInState, checkedState, unCheckedState, checkedAllState, unCheckedAllState,updatePagination,updateSorting
} = billingTypeSlice.actions
 export const taxZoneStateClass = (state: RootState) => state.billingType
 export default billingTypeSlice.reducer